// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-b15a6a5e]{width:400px}", "",{"version":3,"sources":["webpack://./resources/js/Shared/Logo.vue"],"names":[],"mappings":"AAKA,uBACI,WACJ","sourcesContent":["<template>\r\n    <img src=\"/images/logo.png\" class=\"logo\">\r\n</template>\r\n\r\n<style scoped>\r\n.logo {\r\n    width: 400px;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
